<template>
  <div>
    <div class="payment" :class="value === true ? 'on' : ''">
      <div class="title acea-row row-center-wrapper">
        选择付款方式<span class="iconfont icon-guanbi" @click="close"></span>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('weixin') !== -1"
        @click="checked('weixin')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-weixinzhifu"></div>
          <div class="text">
            <div class="name">微信支付</div>
            <div class="info">使用微信快捷支付</div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="hb_fq_list.length > 0"
        @click="checked('alipay')"
				:class="showfq ? 'item-huabei' : ''"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-huabei"></div>
          <div class="text">
            <div class="name">花呗分期</div>
            <div class="info">分期还，更轻松</div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
				<div class="huabei-fenqi" v-if="showfq">
					<div class="fenqi-item" @click="hbPay(item, index)" v-for="(item, index) in hb_fq_list" :key="index" :class="index == selectIndex ? 'selected' : ''">
						<div class="price">{{item.hb_fq_price}}/期</div>
						<div class="info">分{{item.hb_fq_num}}期（含手续费）</div>
					</div>
				</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('yue') !== -1"
        @click="checked('yue')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-yuezhifu"></div>
          <div class="text">
            <div class="name">余额支付</div>
            <div class="info">
              当前可用余额：<span class="money">{{ balance }}</span>
            </div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('offline') !== -1"
        @click="checked('offline')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-yuezhifu1"></div>
          <div class="text">
            <div class="name">线下支付</div>
            <div class="info">选择线下付款方式</div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
    </div>
    <div class="mask" v-show="value" @click="close"></div>
  </div>
</template>
<script>
export default {
  name: "Payment",
  props: {
    value: {
      type: Boolean,
      default: false
    },
		hb_fq_list: {
			type: Array,
			default: () => []
		},
    balance: {
      type: [Number, String],
      default: 0
    },
    types: {
      type: Array,
      default: () => ["weixin", "yue", "offline"]
    }
  },
  data: function() {
    return {
			showfq : false,
			selectIndex : 0,
		};
  },
  mounted: function() {},
  methods: {
		hbPay: function(item, key) {
			this.selectIndex = key;
			this.$emit("checked", 'alipay', item.hb_fq_num);
			this.close();
		},
    checked: function(type) {
			if (type == 'alipay') {
				this.showfq = true;
				
			} else {
				this.$emit("checked", type, 0);
				this.close();
			}
    },
    close: function() {
      this.$emit("input", false);
    }
  }
};
</script>
<style scoped>
.huabei-fenqi {display: flex;justify-content: space-between;
    align-items: center; width: 100%;}
.fenqi-item {width: 2.2rem;
    border: 0.01rem solid #eee;
    border-radius: 8px;
    font-size: 0.24rem;
    padding: 0.1rem 0.05rem;
    text-align: center;
		line-height: 0.36rem;}
.fenqi-item .price{font-weight: bold;}
.fenqi-item .info{font-size: .22rem;}
.fenqi-item.selected {border: 0.02rem solid #1976ff;}
.item-huabei {height: 2.4rem !important;}
.icon-huabei {
	background-image: url("data:image/png;base64,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");
	width: 0.45rem;
	height: 0.45rem;
	background-size: 100%;
	background-repeat: no-repeat;
}
.payment {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0.16rem 0.16rem 0 0;
  background-color: #fff;
  padding-bottom: 0.6rem;
  z-index: 666;
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
}

.payment.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}

.payment .title {
  text-align: center;
  height: 1.23rem;
  font-size: 0.32rem;
  color: #282828;
  font-weight: bold;
  padding-right: 0.3rem;
  margin-left: 0.3rem;
  position: relative;
  border-bottom: 0.01rem solid #eee;
}

.payment .title .iconfont {
  position: absolute;
  right: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.43rem;
  color: #8a8a8a;
  font-weight: normal;
}

.payment .item {
  border-bottom: 0.01rem solid #eee;
  height: 1.3rem;
  margin-left: 0.3rem;
  padding-right: 0.3rem;
}

.payment .item .left {
  width: 6.1rem;
}

.payment .item .left .text {
  width: 5.4rem;
}

.payment .item .left .text .name {
  font-size: 0.32rem;
  color: #282828;
}

.payment .item .left .text .info {
  font-size: 0.24rem;
  color: #999;
}

.payment .item .left .text .info .money {
  color: #ff9900;
}

.payment .item .left .iconfont {
  font-size: 0.45rem;
  color: #09bb07;
}

.payment .item .left .iconfont.icon-zhifubao {
  color: #00aaea;
}

.payment .item .left .iconfont.icon-yuezhifu {
  color: #ff9900;
}

.payment .item .left .iconfont.icon-yuezhifu1 {
  color: #eb6623;
}

.payment .item .iconfont {
  font-size: 0.3rem;
  color: #999;
}
</style>
